import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-bar-badge',
    templateUrl: './bar-badge.component.html',
    styleUrls: [
        './bar-badge.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BarBadgeComponent implements OnInit
{
    @Input() label: string;
    @Input() total: number;
    @Input() value: number;
    @Input() foreColor: string;
    @Input() backColor: string;
    // @Input() fontColor: string;
    @Input() width: number;
    public percent: number;
    public levelWidth: number;
    public svgHeight: number = 30;

    constructor() { }

    ngOnInit ()
    {
        if (this.total === 0)
        {
            this.total = 1;
        }

        this.percent = 100 * this.value / this.total;
        this.levelWidth = this.width * this.percent / 100;
    }
}
